import { render, staticRenderFns } from "./coupons_box.vue?vue&type=template&id=7f19ff1c"
import script from "./coupons_box.vue?vue&type=script&lang=js"
export * from "./coupons_box.vue?vue&type=script&lang=js"
import style0 from "./coupons_box.vue?vue&type=style&index=0&id=7f19ff1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports